import {Card, Divider, Row, Col, Popover} from 'antd';
import {getInvoiceTotals} from "./invoiceUtils";

export const TotalsCard = ({invoiceItems, payments, props}) => {

    const hasPayments = (payments && payments.length > 0);
    const invoiceTotals = getInvoiceTotals(invoiceItems, payments);
    const {subtotal, discountTotal, paymentSum, costSum, profit, profitMargin, amountDue} = invoiceTotals;

    const subtotalPopoverContent = 'Some items do not have prices.  Check to make sure that prices have been entered for all items'

    let subtotalContent, totalContent, profitContent, profitMarginContent;
    if (subtotal === undefined) {
        subtotalContent = <Popover content={subtotalPopoverContent}><div style={{color: 'red', cursor: 'pointer'}}>Enter prices for all items.</div></Popover>
        totalContent = <Popover content={subtotalPopoverContent}><div style={{color: 'red', cursor: 'pointer'}}>$ -.--</div></Popover>
        profitContent = <Popover content={subtotalPopoverContent}><div style={{color: 'red', cursor: 'pointer'}}>$ -.--</div></Popover>
        profitMarginContent = `--.-%`
    } else {
        subtotalContent = `$ ${subtotal.toFixed(2)}`
        totalContent = `$ ${(subtotal - discountTotal).toFixed(2)}`

        let profitStyle = {}
        if (profit > 0) {
            profitStyle = {color: 'green'}
        } else if (profit < 0) {
            profitStyle = {color: 'red'}
        }
        profitContent = <div style={profitStyle}>$ {(subtotal - discountTotal - costSum).toFixed(2)}</div>

        profitMarginContent = <div style={profitStyle}>{profitMargin} %</div>
    }

    return <Card title={'Totals'}>
        <Row>
            <Col span={6}>Subtotal:</Col>
            <Col>{subtotalContent}</Col>
        </Row>
        <Row>
            <Col span={6}>Discount:</Col>
            <Col>$ {discountTotal.toFixed(2)}</Col>
        </Row>
        <Row>
            <Col span={6}>Total Due:</Col>
            <Col>{totalContent}</Col>
        </Row>
        <Row>
            <Col span={24}><Divider /></Col>
        </Row>
        {hasPayments &&
            <Row>
                <Col span={6}>Paid:</Col>
                <Col>{`$ ${paymentSum}`}</Col>
            </Row>
        }
        <Row>
            <Col span={6}>Remaining Balance:</Col>
            <Col>{`$ ${amountDue}`}</Col>
        </Row>
        <Row>
            <Col span={24}><Divider /></Col>
        </Row>
        <Row>
            <Col span={6}>Cost of Goods:</Col>
            <Col>$ {costSum.toFixed(2)}</Col>
        </Row>
        <Row>
            <Col span={6}>Profit:</Col>
            <Col>{profitContent}</Col>
        </Row>
        <Row>
            <Col span={6}>Profit Margin:</Col>
            <Col>{profitMarginContent}</Col>
        </Row>
    </Card>

}